/**
 * Header Search
 *
 * @type {Object}
 */
const search = {

	/**
	 * Initialize.
	 *
	 * @return {void}
	 */
	init() {
		this.headerSearch();
	},

	/**
	 * Header toggle search.
	 *
	 * @return {void}
	 */
	headerSearch() {
		const searchForm = $( '.header-search .search-form' );
		const searchButton = $( '#header-search-icon' );
		const container = $( '#search-form' );

		if ( ! searchButton.length ) {
			return;
		}

		// Show search form.
		searchButton.on( 'click', ( event ) => {

			searchForm.addClass( 'active' );
			event.preventDefault();

			$( window ).on( 'keydown.searchField', keyDown );

			setTimeout( () => {

				$( document ).on( 'click.searchField', documentClick );
				searchForm.find( 'input[type="search"]' ).focus();

			}, 1 );

		} );

		// Hide search form on esc key press.
		const keyDown = function ( event ) {

			if ( searchForm.hasClass( 'active' ) ) {

				if ( 27 === event.keyCode ) {
					searchForm.removeClass( 'active' );
				}

			}

			$( window ).off( 'keydown.searchField' );

		};

		const documentClick = function ( event ) {

			if ( searchForm.hasClass( 'active' ) &&
				( ! container.is( event.target ) && 0 === container.has( event.target ).length ) &&
				( ! searchButton.is( event.target ) && 0 === searchButton.has( event.target ).length ) ) {

				searchForm.removeClass( 'active' );

				$( document ).off( 'click.searchField' );

			}

		};

	}

};

export { search };
